export default {
      id: "logoTRS-usage",
      viewBox: "0 0 8466.66 4199.46",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#logoTRS",
      toString: function () {
        return this.url;
      }
    }